export enum CradleCommands {
  STOP = "stop",
  EMERGENCY_STOP = "emStop",
  SET_SWING_SPEED = 'setSwingSpeed',
  SET_REVERSE_SWING_SPEED = 'setReverseSwingSpeed',
  SET_MIN_MOVING_SPEED = 'setMinMovingSpeed',
  SET_SLOW_SPEED = 'setSlowSpeed',
  SET_SCHEDULER_CHECK_INTERVAL = 'schedulerCheckInterval',
  SET_INIT_POINT = 'setInitPoint',
  SET_HIT_POINT = 'setHitPoint',
  PUBLISH_CURRENT_STATUS = 'pubSt',
  PUBLISH_CONFIG_STATUS = 'pubCfSt',
  RING = "ring",
  CUTSOM_RING = "cstR",
  GET_RING_PATTERNS = "gRPt",
  GET_SCHEDULED_RINGS = "gSch",
  DELETE_SCHEDULED_RING = "delSch",
  UPDATE_SCHEDULED_RING = "updSch",
  DELETE_RING_PATTERN = "delPt",
  UPDATE_RING_PATTERN = "updPt",
  SYNC_RINGER_DATE_TIME = "syncDt",
  SET_LOCK_SCREEN_PIN = "setLockScreenPin",
  SET_LOCK_SCREEN_TIMEOUT = "setLockScreenTimeout"
}

export const silentDispatchList:CradleCommands[] = [CradleCommands.PUBLISH_CURRENT_STATUS,
  CradleCommands.GET_RING_PATTERNS, CradleCommands.GET_SCHEDULED_RINGS]

export class ConfigEntry {
  command:CradleCommands = CradleCommands.STOP;
  value:number = 0;
}

export class ConfigStatus {
  isRinging?: boolean;
  minMovingSpeed?: number;
  speed?: number;
  reverseSpeed?: number;
  slowSpeed?: number;
  deviceTime?: string;
  schedulerCheckInterval?: number;
  initPoint?: number;
  hitPoint?: number;
  screenTimeout?: number;
  screenPin?: string;
  temperature?: number;
  humidity?: number
}

export class BellStatus {
  isRinging?: boolean;
  patternId?: string;
  scheduleId?: string;
}

export class RingPattern {
  id?:string;
  name: string = '';
  pattern: number[] = [1];
  count: number = 1;
  icon?: string;
  isFirstEdit?: boolean = true;
  isEditing?: boolean = true;
}

export interface RingPatterns {
  [key:string]:RingPattern;
}

export interface RespResponse {
  respFor: string;
  data: any;
}

export interface BellStatusMinified {
  r: boolean;
  ptId?: string;
  schId?: string;
  sp: number;
  mSp: number;
  rSp: number;
  slSp: number;
  tm: string;
  schInt: number;
  initPt?: number;
  hitPt?: number;
  scrTime?: number;
  scrPin?: string;
  temp?: number;
  hum?: number;
}

export type MarkerTime =`${number| ''}${number}:${number}${number}`

export class ScheduledRing {
  id?: string = '';
  occurs: OccurenceTypes = OccurenceTypes.DAILY;
  days?: Day[] = [];
  time?:MarkerTime = null;
  pattern: string = null;
  disabled?: boolean;
  isEditing?: boolean = true;
  isFirstEdit?: boolean = true;
}

export enum Day {
  Monday=0,
  Tuesday=1,
  Wednesday=2,
  Thursday=3,
  Friday=4,
  Saturday=5,
  Sunday=6
}

export enum OccurenceTypes {
  SELECTED_DAYS='selectedDays',
  DAILY='daily'
}

export interface ScheduledRings{
  [key:string]: ScheduledRing;
}


export interface LoginResponse{
  access_token: string;
  refresh_token: string;
}

export class LoginConstants{
  static ACCESS_TOKEN: string = 'token';
  static REFRESH_TOKEN: string = 'refresh';
}

export class User {
  username: string;
  userrole: string;
  password?: string;
  church_id: string;
  account_locked?: boolean;
  locked_until?: string;
}

export class UserRoles {
  static SUPER_ADMIN = 'super_admin';
  static ADMIN = 'admin';
  static EDITOR = 'editor';
  static VIEWER = 'viewer';
  static CONTROLLER = 'controller';
}

export const CHURCH_IDS = ['demo1', 'demo2'];
